import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Wireframe gizmo for a collision-shape resource, drawn in the node's `debug_color` like
 * Godot's editor collision overlay. CollisionShape3D mounts it only when `showCollisions` is on.
 */
import { useMemo } from 'react';
import { useConvexDebugLines } from '../../shared/useConvexDebugLines';
import { shapeDebugLines } from '../../shared/shapeDebugLines';
import { GizmoLine } from '../../../../r3f/components/GizmoLine';
import { warn } from '../../../../logger';
import { wireGizmoProgram } from '../../../../r3f/components/wireGizmoProgram';
export function CollisionGizmo({ shape, color }) {
    switch (shape.type) {
        case 'BoxShape3D':
        case 'CapsuleShape3D':
        case 'SphereShape3D':
        case 'CylinderShape3D':
        case 'WorldBoundaryShape3D':
        case 'HeightMapShape3D':
        case 'SeparationRayShape3D':
        case 'ConcavePolygonShape3D':
            return _jsx(ShapeLines, { shape: shape, color: color });
        case 'ConvexPolygonShape3D':
            return _jsx(ConvexHullLines, { shape: shape, color: color });
        default: {
            const wire = wireGizmoProgram(color);
            warn(`[CollisionShape3D] Unsupported shape type "${shape.type}": drawing a unit wireframe box.`);
            return (_jsxs("mesh", { children: [_jsx("boxGeometry", { args: [1, 1, 1] }), _jsx("meshBasicMaterial", { ...wire.props }, wire.key)] }));
        }
    }
}
/** The lines of Godot's `get_debug_mesh_lines()`, which its editor collision overlay draws for a shape. */
function ShapeLines({ shape, color }) {
    const positions = useMemo(() => shapeDebugLines(shape), [shape]);
    return positions && _jsx(GizmoLine, { positions: positions, color: color });
}
/** The hull edges of a convex shape, which draw once the lazy hull builder loads. */
function ConvexHullLines({ shape, color }) {
    const positions = useConvexDebugLines(shape);
    return positions && _jsx(GizmoLine, { positions: positions, color: color });
}
//# sourceMappingURL=CollisionGizmo.js.map